// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file credential_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file credential_type.proto.
 */
export const file_credential_type: GenFile = /*@__PURE__*/
  fileDesc("ChVjcmVkZW50aWFsX3R5cGUucHJvdG8SBmRvbWFpbipsCg5DcmVkZW50aWFsVHlwZRIbChdDUkVERU5USUFMX1RZUEVfVU5LTk9XThAAEiAKHENSRURFTlRJQUxfVFlQRV9TRUNVUklUWV9LRVkQARIbChdDUkVERU5USUFMX1RZUEVfUEFTU0tFWRACQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.CredentialType
 */
export enum CredentialType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: CREDENTIAL_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CREDENTIAL_TYPE_SECURITY_KEY = 1;
   */
  SECURITY_KEY = 1,

  /**
   * @generated from enum value: CREDENTIAL_TYPE_PASSKEY = 2;
   */
  PASSKEY = 2,
}

/**
 * Describes the enum domain.CredentialType.
 */
export const CredentialTypeSchema: GenEnum<CredentialType> = /*@__PURE__*/
  enumDesc(file_credential_type, 0);

